import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { BaseResponseHttp } from '../model/http/commons.model';
import { DeleteItemsRequest } from '../model/local/missing-list-product.model';
import { ConsumeService } from './consume.service';

@Injectable({
  providedIn: 'root'
})
export class DeleteItemsService {

  constructor(private consume: ConsumeService) { }

  deleteItems(request: DeleteItemsRequest): Observable<BaseResponseHttp> {
    return this.consume.httpPost(`${Endpoints.deleteItems.delete}`, request);
  }
}
